<h2 mat-dialog-title>{{data.title}}</h2>
<div mat-dialog-content>
  @if (!data.isHtmlMessage) {
    <p>{{data.message}}</p>
  }
  @if (data.isHtmlMessage) {
    <p [innerHTML]="data.message"></p>
  }
</div>
<div class="dialog-buttons" mat-dialog-actions>
  <button mat-button mat-raised-button color="primary" (click)="onConfirm()"
  [ngClass]="{'right-align-button': hideCancelButton }">{{acceptButtonText}}</button>
  @if (!hideAlternateButton) {
    <button mat-button mat-raised-button color="primary" (click)="onAlternate()">{{alternateButtonText}}</button>
  }
  @if (!hideCancelButton) {
    <button mat-button mat-raised-button color="accent" (click)="onCancel()">{{declineButtonText}}</button>
  }
</div>